export interface IPageSeoInfo {
  pageTemplate: string | null;
  availableLangs: ('en' | 'ms-my')[];
}

export const usePageSeoInfo = () => {
  return useState<IPageSeoInfo | null>('page-seo-info', () => null);
};